<template>
	<div class="main footer-container">
		<!-- 内容区域 -->
		<div class="footer-content color-grey8">
			<!-- 高报服务列表 -->
			<div class="footer-col">
				<h3 class="footer-title">高报服务</h3>
				<ul class="service-list">
					<li class="service-item" v-for="(item,index) in serviceList" :key="index"
						@click="$toPage(item.url+(item.id?'?id='+item.id:''))">
						{{ item.name }}
					</li>
				</ul>
			</div>

			<!-- 咨询时间 -->
			<div class="footer-col">
				<h3 class="footer-title">咨询时间</h3>
				<div class="time-info">
					<p>热线咨询时间：</p>
					<p>{{info.hot_consult_time||''}}</p>
					<p>门客咨询时间：</p>
					<p>{{info.retainer_consult_time||''}}</p>
				</div>
			</div>

			<!-- 联系我们 -->
			<div class="footer-col">
				<h3 class="footer-title">联系我们</h3>
				<div class="contact-info">
					<p class="font20 color-black weight550">{{info.contact}}</p>
					<p class="width275">地址：{{info.address||''}}</p>
				</div>
			</div>

			<!-- 二维码区域 -->
			<div class="footer-col qr-col">
				<div class="qr-item" v-if="info.wechat_qrcode">
					<img :src="info.wechat_qrcode" alt="微信小程序" class="qr-code" />
					<p>微信小程序</p>
				</div>
				<!-- <div class="qr-item" v-if="info.app_qrcode">
					<img :src="info.app_qrcode" alt="下载APP" class="qr-code" />
					<p>下载APP</p>
				</div> -->
			</div>
		</div>

		<!-- 版权信息 -->
		<div class="copyright">
			<div>
				{{info.copyright}} 版权所有All rights Reserved
			</div>
			<div>
				备案号：<span class="cursor-active">{{info.internet_content_provider}}</span>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		footer
	} from '@/api/com';
	export default {
		name: 'ComFooter',
		data() {
			return {
				// 高报服务列表
				serviceList: [{
					name: '志愿填报',
					url: 'user'
				}, {
					name: '高校专项计划',
					url: 'service',
					id: 1
				}, {
					name: '强基计划',
					url: 'service',
					id: 2
				}, {
					name: '综合评价',
					url: 'service',
					id: 3
				}, {
					name: '留学',
					url: 'service',
					id: 4
				}],
				info: ''
			}
		},
		created() {},
		mounted() {
			this.getInfo()
		},
		methods: {
			getInfo() {
				footer().then(res => {
					this.info = res.data
				}).catch(err => {
					// this.$message.error(' ');
				})
			},
			toDetail(url, type) {
				if (type) {
					this.$router.push({
						path: url,
						query: {
							id: type,
						}
					})
				} else {
					this.$router.push(url)
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.footer-container {
		background: rgba(255, 255, 255, .45);
		border-radius: 8px;
		margin-top: 40px;

		// 内容区域（栅格布局）
		.footer-content {
			padding: 40px 20px 20px;
			display: flex;
			justify-content: space-between;
			align-items: start;
			// display: grid;
			// grid-template-columns: repeat(5, 1fr); // 4列均分
			// gap: 20px;
		}

		// 列标题
		.footer-title {
			font-size: 17px;
			font-weight: bold;
			color: #303133;
			margin-bottom: 15px;
		}

		// 服务列表
		.service-list {
			list-style: none;
			padding: 0;
			margin: 0;

			.service-item {
				margin-bottom: 15px;
				cursor: pointer;

				&:hover {
					color: #28b05e;
				}
			}
		}

		// 时间/联系信息
		.time-info,
		.contact-info {
			line-height: 24px;
		}

		// 二维码列
		.qr-col {
			display: flex;
			justify-content: center;
			gap: 55px;
			margin-top: 30px;
			margin-right: 20px;

			.qr-item {
				text-align: center;

				.qr-code {
					width: 94px;
					// height: 94px;
					margin-bottom: 5px;
				}
			}
		}

		// 版权信息
		.copyright {
			padding-top: 10px;
			padding-bottom: 10px;
			line-height: 20px;
			border-top: 1px solid #EBEEF5;
			text-align: center;
			color: #909399;

		}
	}
</style>
